Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
const core = require('@sentry/core');
const WINDOW = core.GLOBAL_OBJ;
exports.WINDOW = WINDOW;